import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components";
import { Stack } from "basis";

import Text from'./Text'

import { COLOR } from "./theme";

const StyledInput = styled.input`
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  color: ${COLOR.DARK_GREY};
  height: 48px;
  margin: 0;
  border-style: solid;
  border-color: ${COLOR.GREY_INACTIVE};
  border-radius: 5px;
  appearance: none;
  outline: none;
  padding-left: 16px;
  font-weight: 200;

  &:focus {
    border-color: ${COLOR.HIGHLIGHT_BLUE};
  };

  ${(props) =>
    props.error &&
    css`
      border-bottom: 4px solid ${COLOR.RED};
    `}
  ${(props) =>
    props.borderWidth &&
    css`
      border-width: ${props.borderWidth}px;
    `}
  ${(props) =>
    props.mt &&
    css`
      margin-top: ${props.mt}px;
    `}
${(props) =>
  props.fontFamily &&
  css`
    font-family: ${props.fontFamily}, sans-serif;
  `}

  ${(props) =>
    props.textColor &&
    css`
      color: ${props.textColor};
    `}

  ${(props) =>
    props.placeholderColor &&
    css`
      &::placeholder {
        color: ${props.placeholderColor};
        opacity: 1;
      }
    `}
  
  ${(props) =>
    props.backgroundColor &&
    css`
      background-color: ${props.backgroundColor};
    `};
  }`;

export const Input = ({
  name,
  placeholder,
  label,
  value,
  disabled,
  fontFamily,
  textColor,
  placeholderColor,
  fontWeightLabel,
  backgroundColor,
  onChange = () => {},
  validate = () => null,
  ...props
}) => {
  const [state, setState] = useState({ value: "", error: false });

  const handleChange = (e) => {
    const value = e.target?.value;
    const error = validate(value);

    setState({ value, error });
    onChange({ value, error });
  };

  useEffect(() =>{
    const error = validate(value);
    setState({ value, error });
  }, [value])

  return (
    <Stack>
      <Text color={textColor} fontFamily={fontFamily} fontWeight={fontWeightLabel}>
        {label}
      </Text>

      <StyledInput
        name={name}
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        fontFamily={fontFamily}
        onChange={handleChange}
        error={state.error}
        textColor={textColor}
        placeholderColor={placeholderColor}
        backgroundColor={backgroundColor}
        {...props}
      />

      {state.error && (
        <Text
          textStyle="body2"
          color="conditional.negative.text"
          fontFamily={fontFamily}
        >
          {state.error}
        </Text>
      )}
    </Stack>
  );
};
